import React, { Component } from 'react';
import { formatDatePtBr } from '../../../utils';
import api from '@api';

export default class ListarAtestesDeCampo extends Component {
	constructor() {
		super();
		this.state = {
			listaDeAtestes: [],
		};

		this.carregarListaDeAtestes = this.carregarListaDeAtestes.bind(this);
	}

	UNSAFE_componentWillMount() {
		this.carregarListaDeAtestes();
	}

	carregarListaDeAtestes() {
		api.atestesDeCampo.ListaTodos()
			.then((listaDeAtestes) => {
				this.setState({ listaDeAtestes });
			})
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	apagarAteste(id) {
		api.atestesDeCampo.RemovePelaId(id)
			.then(() => {
				this.setState(prevState => {
					const listaDeAtestes = prevState.listaDeAtestes.filter(ateste => ateste.id !== id);
					return { listaDeAtestes };
				});
			})
			.catch((erro) => {
				console.log('erro', erro);
			});
	}

	render() {
		const { listaDeAtestes } = this.state;

		return (
			<div>
				<h5>Relação de Atestes de Campo</h5>
				<table className="table table-striped table-hover">
					<thead>
						<tr>
							<th></th>
							<th></th>
							<th>Campo de Estágio</th>
							<th>Responsável</th>
							<th>Curso</th>
							<th>Vigência</th>
							<th />
						</tr>
					</thead>
					<tbody>
						{
							listaDeAtestes.map((ateste, i) => {
								const { responsavel, local_de_estagio, curso, vigencia } = ateste;

								return (
									<tr key={ateste.id} title={ateste.observacoes}>
										<td>{ateste.ativo && <>{'>'}</>}</td>
										<td>{i + 1}</td>
										<td>{local_de_estagio.nome}</td>
										<td>{responsavel.nome}</td>
										<td>{curso.nome}</td>
										<td>
											{`${formatDatePtBr(new Date(vigencia.inicio))} a ${formatDatePtBr(new Date(vigencia.fim))}`}
										</td>
										<td>
											<button onClick={() => this.apagarAteste(ateste.id)}>Apagar</button>
										</td>
									</tr>
								);
							})
						}
					</tbody>
				</table>
			</div>
		);
	}
}
